import { createContext, useState } from 'react';

const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);

  const addMessage = (newMessage) => {
    const existentMessage = messages?.find(item => item.id === newMessage.id)
    if (!existentMessage) {
      let messagesAux = [...messages]
      messagesAux.push(newMessage)
      setMessages(messagesAux)
    }
  }

  const removeMessage = (id) => {
    setMessages((prev) => {
      if (!prev.find(msg => msg.id === id)) return prev;
      return prev.filter((msg) => msg.id !== id);
    });
  };

  return (
    <MessageContext.Provider value={{ addMessage, messages, setMessages, removeMessage }}>
      {children}
    </MessageContext.Provider>
  );
};

export default MessageContext;